export default __webpack_public_path__ + "static/media/cart-empty.b50a22cf.png";